import { graphql } from '@mews-commander/guest-profile';

export const GuestProfileBasicFieldsFragment = graphql(`
    fragment GuestProfileBasicFields on GuestProfile {
        id
        createdUtc
        email
        firstName
        fullName
        imageId
        lastName
        phone
        updatedUtc
        number
        paymentCard {
            lastDigits
            type
        }
    }
`);

export const GuestProfileAdditionalFieldsFragment = graphql(`
    fragment GuestProfileAdditionalFields on GuestProfile {
        accountingCode
        billingCode
        birthDate
        birthPlace
        carRegistrationNumber
        loyaltyCode
        loyaltyMembership {
            ...LoyaltyMembershipBasicFields
        }
        nationalityCode
        occupation
        preferredLanguageCode
        secondLastName
        sex
        taxIdentifier
        titlePrefix
        updatedUtc
    }
`);

export const GuestProfileFieldsFragment = graphql(`
    fragment GuestProfileFields on GuestProfile {
        ...GuestProfileBasicFields
        ...GuestProfileAdditionalFields
    }
`);
